import { ContactFragment } from "@/__generated__/graphql";
import { DataViewThreadActions } from "@/components/organisms/DataView/DataViewThreadActions";
import { type TableDialogSelectionActionsProps } from "@/components/organisms/Table/TableDialog";
import { ThreadMessageContextItemType } from "@/state/@types";

export function contactToThreadContext(
  contact: ContactFragment,
): ThreadMessageContextItemType {
  return {
    id: contact.id,
    identifier: contact.identifier,
    name: contact.name || contact.organization?.name || "Untitled",
    typename: "ContactObject",
  };
}

export const CONTACT_THREAD_MENU_OPTIONS = [
  { id: "matching-transactions", message: "Find transactions" },
  { id: "reconcile", message: "Reconcile" },
] as const;

type ContactsViewThreadActionsProps = TableDialogSelectionActionsProps & {
  onPrepareThread: (checkedRowIds: string[], draft?: string) => void;
};

export function ContactsViewThreadActions({
  menuOptions = CONTACT_THREAD_MENU_OPTIONS,
  ...props
}: ContactsViewThreadActionsProps & {
  menuOptions?: typeof CONTACT_THREAD_MENU_OPTIONS;
}) {
  return <DataViewThreadActions {...props} menuOptions={[...menuOptions]} />;
}
